import styled from 'styled-components';

export const ErrorMessage = styled.strong`
    font-family: 'Spoqa Han Sans Neo';
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1rem;
`;
